/* eslint-disable */
const getters = {
  getPeriodicDiscounts(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
